export default __webpack_public_path__ + "static/media/035-pie.ba9cd50f.svg";